import type { StorefrontBootstrap } from "@emynor/storefront-sdk";
import type { Lang } from "./types";

export function legalText(bootstrap: StorefrontBootstrap, key: "privacy" | "terms" | "refund", lang: Lang): string {
  const legal = section(bootstrap.settings?.configuration, "policies");
  const localized = section(legal, key);
  const content = stringValue(localized[lang]) || stringValue(localized["en"]) || stringValue(localized["ar"]);
  if (content) return content;
  return lang === "ar"
    ? "لم ينشر المطعم هذه السياسة بعد."
    : "The restaurant has not published this policy yet.";
}

export function hasLegalText(bootstrap: StorefrontBootstrap, key: "privacy" | "terms" | "refund"): boolean {
  const legal = section(bootstrap.settings?.configuration, "policies");
  const localized = section(legal, key);
  return Boolean(stringValue(localized["en"]) || stringValue(localized["ar"]));
}

function section(value: unknown, key: string): Record<string, unknown> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const child = (value as Record<string, unknown>)[key];
  return child && typeof child === "object" && !Array.isArray(child) ? child as Record<string, unknown> : {};
}

function stringValue(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}
